module.exports = __webpack_public_path__ + "assets/img/clarify_thinking.79b24a28.png";